<microsec-card [isBordered]="true">
  <div class="flex flex-col gap-4 w-full xl:pr-[12rem]">
    <div class="font-bold text-xl">Platform Configuration</div>
    <div class="text-gray-500">
      <span>Only modify these settings if you need to configure MicroIDS to download analyzer rules from local TIP.&nbsp;</span>
      <span>By default, MicroIDS is set to use MicroSec's online TIP.</span>
      <a (click)="goToDocumentation()" target="_blank" class="text-blue-500 hover:underline cursor-pointer">
        Learn more about the Threat Intelligence Platform.
      </a>
    </div>
    <microsec-form-builder #fb [isPage]="true" [fields]="fields()" [shouldShowActionButtons]="false" />
    <p-divider styleClass="my-1" />
    <div class="flex gap-2">
      <p-button severity="secondary" label="Cancel" (onClick)="getConfigData(false)" [disabled]="isLoading()" />
      <p-button severity="primary" label="Reset to Default" (onClick)="getConfigData(true)" [disabled]="isLoading()" />
      <p-button severity="success" label="Save Changes" (onClick)="onSubmit()" [disabled]="shouldDisableSubmit()" />
    </div>
  </div>
</microsec-card>
